import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Avatar, DataTable, Button, IconButton, Appbar ,Snackbar,Text} from 'react-native-paper';
import { CommonActions } from '@react-navigation/native';

const sportIcons = { 
  
  "اسپینینگ":
  require("../assets/sportsicons/spin.png"),

  "ایروبیک":
  require("../assets/sportsicons/rhytm.png"),

  "بدنسازی":
  require("../assets/sportsicons/gym.png"),

  "تمرینات فانکشنال / کراسفیت":
  require("../assets/sportsicons/cf.png"),

  "تمرینات لس میلز":
  require("../assets/sportsicons/bp.png"),

  "تمرینات معلق":
  require("../assets/sportsicons/trx.png"),

  "جامپینگ فیتنس":
  require("../assets/sportsicons/jump.png"),

  "فیتنس":
  require("../assets/sportsicons/fit.png"),

  "دوچرخه سواری":
  require("../assets/sportsicons/bike.png"),

  "ورزش های آبی":
  require("../assets/sportsicons/swim.png"),

  "ورزش های آزاد":
  require("../assets/sportsicons/free.png"),

  "ورزش کودکان":
  require("../assets/sportsicons/kids.png"),

  "کیک بوکس / رزمی":
  require("../assets/sportsicons/kb.png"),

  "یوگا / پیلاتس":
  require("../assets/sportsicons/yoga.png"),

  "متفرقه":
  require("../assets/sportsicons/other.png"),

} ;

export default class App extends React.Component {

    state = {
      count:1,
      toastVisible : false,
      message : '',
      buttonDisable: false,
      connectionToast:false
    };
  

  render() {
    return (
      <View style={{backgroundColor:'#ebebeb', height:'100%'}}>
      <Appbar.Header style={{height:50,backgroundColor:'white'}} >
        <Appbar.Action icon="menu" color='#3a3635' onPress={() => this.props.navigation.openDrawer()} />
        <Appbar.Content title='تایید رزرو'/>
        <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />
      </Appbar.Header>

      <View style={styles.container}>

        <View style={{flexDirection:'row'}}>
        <Avatar.Image style={{marginHorizontal:20,backgroundColor:'white'}} size={50} source={{uri : global.image.uri}} />
         <View>
         <Text style={{ color:'#3a3635',fontSize:16}}>{global.fname} {global.lname}</Text>
         <View style={{flexDirection:'row'}}>
          <IconButton icon='card-bulleted-outline' style={{margin:-10,marginTop:-8}} />
          <Text style={{marginHorizontal:5}}> {global.credit} تومان</Text>
         </View>
         </View>
        </View>

        <View style={{justifyContent:'center',alignItems:'center',marginRight:25}}>
          <Text style={{fontFamily:'iransansb',fontSize:24}}>{global.creditExpire}</Text>
          <Text style={{marginTop:-10}}>روز باقیمانده</Text>
        </View>
 
      </View>
      <View style={{padding:30}}>

        <DataTable style={{backgroundColor:'white',borderRadius:10,marginRight:'auto',marginLeft:'auto',elevation:4}}>
        <DataTable.Row style={{height:80}}>
          <View style={{flexDirection:'row',alignItems:'center'}}>
            <Avatar.Image  style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[global.activeClassInfo.sport]} />
            <View style={{marginHorizontal:15}}>
              <Text style={{ color:'#3a3635',fontSize:14}}>{global.activeClassInfo.classname}</Text>
              <Text style={{ color:'#3a3635',fontSize:12}}>مربی : {global.activeClassInfo.trainer}</Text>
            </View>
            
          </View>
          
        </DataTable.Row>
        <DataTable.Row>
          <DataTable.Cell><Text style={{fontSize:12}}>باشگاه</Text></DataTable.Cell>
          
          <DataTable.Cell><Text style={{fontSize:12}}>{global.activeClassInfo.gymname}</Text></DataTable.Cell>
        </DataTable.Row>
        <DataTable.Row>
          <DataTable.Cell><Text style={{fontSize:12}}>تاریخ</Text></DataTable.Cell>
         
          <DataTable.Cell><Text style={{fontSize:12}}>{global.acDate.format('L')}</Text></DataTable.Cell>
        </DataTable.Row>
        <DataTable.Row>
          <DataTable.Cell><Text style={{fontSize:12}}>ساعت شروع</Text></DataTable.Cell>
          
          <DataTable.Cell><Text style={{fontSize:12}}>{global.activeClassInfo.starttime}</Text></DataTable.Cell>
        </DataTable.Row>
        <DataTable.Row>
          <DataTable.Cell><Text style={{fontSize:12}}>قیمت</Text></DataTable.Cell>
          
          <DataTable.Cell><Text style={{fontSize:12}}>{global.activeClassInfo.price} تومان</Text></DataTable.Cell>
        </DataTable.Row>
        <DataTable.Row style={{backgroundColor:'#f2e5d7'}}>
          <DataTable.Cell><Text style={{fontSize:12}}>رزرو گروهی</Text></DataTable.Cell>
         
          <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center'}}>
          <IconButton
            icon="chevron-up"
            color='#3a3635'
            size={18}
            onPress={()=>{this.setState({count:this.state.count+1})}}
            style={{margin:7,marginTop:'auto',marginBottom:'auto',marginLeft:-7, marginRight:7}}
            disabled={(this.state.count==5)? true : false}
          />
          <Text style={{marginTop:'auto',marginBottom:'auto' ,fontSize:12, color:'#3a3635'}}>
          {this.state.count} نفر 
          </Text>
          <IconButton
            icon="chevron-down"
            color='#3a3635'
            size={18}
            onPress={()=>{this.setState({count:this.state.count-1})}}
            style={{margin:7,marginTop:'auto',marginBottom:'auto'}}
            disabled={(this.state.count==1)? true : false}
          />
          </View>
          
        </DataTable.Row>
        <DataTable.Row>
          <DataTable.Cell><Text style={{fontSize:16}}>مجموع</Text></DataTable.Cell>
          
          <DataTable.Cell><Text style={{fontSize:16}}>{this.state.count*global.activeClassInfo.price} تومان</Text></DataTable.Cell>
        </DataTable.Row>
        </DataTable>

        <Button mode='contained' dark={true} style={styles.button} color='#2ebbc4' 
          disabled={this.state.buttonDisable}
          loading={this.state.buttonDisable}
          onPress={() => {

            this.setState({buttonDisable:true});

            fetch('https://fitwayz.ir/api/users/sessions/' + global.activeClassId + '/reserve',
            {
              method:'POST',
              withCredentials: true,
               
              headers:{
                Accept: 'application/json',
                Authorization: 'Bearer ' + global.token,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                quantity : this.state.count
              })
            })
            .then(response => response.json()).then(responseJson => {
              if(responseJson.result == 'success'){
                global.credit= responseJson.updatedcredit;
                this.setState({message:'رزرو شما با موفقیت ثبت شده', toastVisible:true});
              }else{
                this.setState({message:responseJson.error, toastVisible:true, buttonDisable:false});
              }
            })
            .catch(error => {
              this.setState({connectionToast:true, buttonDisable:false})
            });

          } }
          contentStyle={{width:170,height:46}}>تایید رزرو</Button>


      </View>

      <Snackbar
          style={{zIndex:200,elevation:10}}
          visible={this.state.toastVisible}
          onDismiss={() => {
            this.setState({ toastVisible: false });
            if(this.state.message.indexOf('اعتبار') >= 0 ){
              this.props.navigation.navigate('Plans')
            }

            if(this.state.message.indexOf('پایان') >= 0 ){
              this.props.navigation.navigate('Plans')
            }

            if(this.state.message.indexOf('موفقیت') >= 0 ){
              let resetAction = CommonActions.reset({
                index: 0,
                routes:[{name:'Profile'},]
              });
              this.props.navigation.dispatch(resetAction);
              this.props.navigation.navigate('ProfileRoute')
            }
        }}>
          {this.state.message}
        </Snackbar>

        <Snackbar
          style={{zIndex:200,elevation:10}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>

      </View>

    );
  }
}

const styles = StyleSheet.create({

  container: {
    backgroundColor: 'white',
    flexDirection:'row',
    elevation:4,
    paddingBottom:10,
    justifyContent:'space-between'
  },
  button:{
    marginLeft:'auto',
    marginRight:'auto',
    borderRadius:23,
    marginTop:30,
    zIndex:1
  }
});
